import './Questionnaire.scss';
import { Box } from '@mui/material';
import { isEmpty } from '../APIs/Helpers';
//import { SpAPIgetQuestionnaire } from '../APIs/QuestionnaireProfileAPI';
//import { SpAPIsubmitQuestionnaire } from '../APIs/QuestionnaireProfileAPI';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//import questionnaireForm from '../../../components/SellerProfile/Form/json/questionnaireFormFields.json';
import SPForm from '../../../components/SellerProfile/Form/SPForm';
import SPFormButton from '../../../components/SellerProfile/Form/SPFormButton';
import { setOnboardingStatus,setShowSuccessPopUp,setErrorMsg,setOnboardCompletePopupDetails } from '../../../redux/slices/sellerProfileSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchQuestionnaireRequest, submitQuestionnaireRequest } from '../../../redux/slices/questionnaireSlice';

const Questionnaire = () => {
  const dispatch = useDispatch();
  const { onboardingStatus, user_id ,formUpdates} = useSelector((state: any) => state.sellerProfile);
  const { questionnaireForm, loading, submissionSuccess } = useSelector((state: any) => state.questionnaire);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const displayErrorByType = (error) => {
    if (error.response?.data?.err_code === 402) {
     dispatch(setErrorMsg(t('sellerProfile.dashboard.questionnaireAlreadySubmitted')));
    } else {
      dispatch(setErrorMsg(t('sellerProfile.dashboard.errorSubmittingQuestionnaire')));
    }
  };

  useEffect(() => {
    dispatch(fetchQuestionnaireRequest({ language: i18n.language }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    if (submissionSuccess) {
      dispatch(setShowSuccessPopUp(t('sellerProfile.dashboard.questionnaireSubmitted')));
      if (onboardingStatus?.completed === 2) {
        let statusChange = {
          completed: 3,
          questionnaire: true,
          notification: true,
          user: true
        }
        dispatch(setOnboardingStatus({ ...statusChange }));
        dispatch(setOnboardCompletePopupDetails({
          show: true,
          navigate: true,
          close: false,
        }));
      } else {
        console.log('Onboarding status is not 2, navigating to seller profile');
        navigate(`/${i18n.language}/seller-profile`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionSuccess, onboardingStatus]);

  const submitFormFields = async () => {
    try {
      dispatch(submitQuestionnaireRequest({
        formUpdates: formUpdates,
        user_id: user_id,
        language: i18n.language
      }));
    } catch (error) {
      displayErrorByType(error);
    }
  }
  useEffect(() => {
  }, []);

  return loading ? (
    <div></div>
  ) :
    !isEmpty(questionnaireForm) ? (
      <Box className="questionnaireBox">
        <form>
          <SPForm
            cols="single"
            compName="questionnaire"
            formFields={questionnaireForm}
            formName="questionnaire"
            key="questionnaire"
          />
          <div className="questionnaireButton">
            {
              <SPFormButton
                compName="SPQuestionnaire"
                formName="questionnaire"
                label={t('sellerProfile.dashboard.submitQuestionnaire')}
                showLoading={loading}
                handleClick={() => submitFormFields()}
              />
            }
          </div>
        </form>
      </Box>
    ) : (
      <></>
    );
};

export default Questionnaire;
